package com.milta.core.localization.translations.bg

import com.milta.core.localization.WebImportRouteStrings

internal val WebImportRoute = WebImportRouteStrings(
    headerSubtitle = "Качете файл с доставки и го възложете на шофьор",
    stepImport = "Импортиране",
    stepVerifyAssign = "Проверка и възлагане",
    stepValidateSend = "Потвърди и изпрати маршрутите",
    dropzoneTitle = "Плъзнете и пуснете вашия файл с доставки",
    dropzoneOrPrefix = "или",
    browseFilesLink = "разгледайте вашите файлове",
    browseFilesButton = "Разгледай файловете",
    constraintsLabel = "Excel (.xlsx, .xls), CSV или PDF · макс. 500 спирки · 10 MB",
    expectedColumnsEyebrow = "Очаквани колони във файла",
    columnRecipientName = "Име на получателя",
    columnAddress = "Пълен адрес",
    columnDeadline = "Краен час",
    columnPhone = "Телефон",
    requiredPillLabel = "Задължително",
    optionalPillLabel = "По избор",
    analysingLabel = "Анализиране…",
    analysingCanLeaveLabel = "Файлът е изпратен. Можете да напуснете тази страница, анализът продължава.",
    importOnMobileMessage = "В мобилното приложение тече импорт (%s). Завършете го в приложението, за да импортирате друг файл тук.",
    invalidFileTitle = "Нечетим файл или неподдържан формат",
    invalidFileMessage = "„%s“ не можа да бъде анализиран. Използвайте файл Excel (.xlsx, .xls), CSV или PDF, съответстващ на очакваните колони.",
    chooseAnotherFileButton = "Изберете друг файл",
    extractionFailedTitle = "Доставките не могат да бъдат извлечени",
    extractionFailedMessage = "Файлът „%s“ беше прочетен, но не бе намерен използваем ред. Проверете дали съдържа очакваните колони.",
    serviceUnavailableTitle = "Услугата за анализ временно не е налична",
    serviceUnavailableMessage = "В момента не можем да анализираме вашия файл. Файлът ви е запазен: опитайте отново след малко.",
    retryButton = "Опитай отново",
    fileImportedStatus = "Файлът е импортиран",
    stopsDetectedSuffix = "открити спирки",
    replaceFileLink = "↺ Замени",
    assignToEyebrow = "Възложи на",
    selectDriverRequiredError = "Моля, изберете поне един шофьор преди да изпратите маршрута.",
    selectedDriversCountSuffix = "избрани шофьори",
    optimizeRouteButton = "Оптимизирай маршрута",
    tableCaptionLead = "Проверете и коригирайте спирките преди изпращане",
    tableCaptionHint = "Кликнете върху молива, за да коригирате ред",
    locationBlockedHint = "Всеки ред трябва да има локализиран адрес (GPS), преди да бъде изпратен на шофьорите. Коригирайте засегнатите редове (✎) или опитайте геокодирането отново.",
    columnHeaderIndex = "#",
    columnHeaderRecipientName = "Име на получателя",
    columnHeaderAddress = "Адрес",
    columnHeaderPhone = "Телефон",
    columnHeaderDeadline = "Краен час",
    columnHeaderPackageCount = "Колети",
    dashPlaceholder = "—",
    discardDraftButton = "Отказ от импорта",
    discardDraftDialogTitle = "Да се откаже ли този импорт?",
    discardDraftDialogMessage = "Вече импортираните доставки ще бъдат загубени завинаги. Това действие не може да бъде отменено.",
    discardDraftConfirmButton = "Да, откажи импорта",
    freeFormatBanner = "Открит е свободен формат — колоните не можаха да бъдат разпознати автоматично, проверете всеки ред преди изпращане.",
    incompleteStopsBannerSuffix = "непълни спирки — липсва име или адрес, за коригиране преди изпращане.",
    rowFlagMissingName = "⚠ липсва име",
    rowFlagMissingAddress = "⚠ липсва адрес",
    alreadyDispatchedBanner = "Този маршрут вече е изпратен на шофьор — презаредете страницата, за да започнете нов импорт.",
    routeNotFoundError = "Маршрутът не е намерен. Презаредете страницата и опитайте отново.",
    validationErrorGeneric = "Моля, проверете въведената информация.",
    submitServerError = "Възникна грешка. Опитайте отново.",
    submitOptimizationUnavailableError = "Услугата за оптимизация временно не е налична. Маршрутът не беше създаден — опитайте отново след малко.",
    sendWithoutOptimizationButton = "Изпрати без оптимизация",
    dispatchSuccessMessage = "Маршрутът е изпратен успешно на %s",
    dispatchSuccessBatchMessage = "Маршрутите са изпратени успешно на %d шофьори",
    tooManyStopsError = "Този файл съдържа повече от 500 доставки. Моля, разделете го, преди да го импортирате.",
    resultHeaderMiddle = "доставки, разпределени между",
    resultDriverSingularSuffix = "шофьор",
    resultDriverPluralSuffix = "шофьори",
    resultDistanceLabel = "Разстояние",
    resultDurationLabel = "Прогнозна продължителност",
    resultMetricNotCalculatedLabel = "Неизчислено",
    resultStopsChipSuffix = "спирки",
    resultMoreStopsTemplate = "+ %d други спирки",
    resultStopsLoadError = "Спирките на този маршрут не можаха да се заредят.",
    resultDispatchButton = "Потвърди и изпрати маршрутите",
)
